import { CompanyOfSearchModal } from '@doda/common/src/models/MasterCacheModel';
import { CheckState } from './checkedStationStateReducer';

/**
 * チェックのついた路線の駅を抽出する関数
 * @param {DisplayRailwayCompany[]} railwayCompanies - 鉄道会社のデータ
 * @param {string[]} checkedAllRoute - チェックされた路線のID配列
 * @returns {string[]} チェックされた路線に属する駅のID配列
 */
const getStationIdsByRoutes = (
  railwayCompanies: CompanyOfSearchModal[],
  checkedAllRoute: string[]
): string[] =>
  railwayCompanies
    .flatMap((company) => company.routeList)
    .filter((route) => checkedAllRoute.includes(route.id))
    .flatMap((route) => route.stationList.map((station) => station.id));

/**
 * 選択されている路線の駅のIDを全て含める関数
 * @param {CompanyOfSearchModal[]} railwayCompanies - 路線・駅データ
 * @param {Object} options - チェック状態のオプション
 * @param {string[]} options.checkedAllRoute - チェックされた全ての路線
 * @param {string[]} options.checkedStation - チェックされた駅
 * @returns {Pick<CheckState, 'railwayCompanies' | 'checkedAllRoute' | 'checkedStation'>} 更新後のチェック状態
 */
export const includeStationChildIds = (
  railwayCompanies: CompanyOfSearchModal[],
  {
    checkedAllRoute,
    checkedStation,
  }: Pick<CheckState, 'checkedAllRoute' | 'checkedStation'>
) => {
  const includedStation = getStationIdsByRoutes(
    railwayCompanies,
    checkedAllRoute
  );

  // 重複を排除
  const uniqueIncludedStation = [
    ...new Set([...includedStation, ...checkedStation]),
  ];

  return {
    checkedAllRoute,
    checkedStation: uniqueIncludedStation,
  };
};

/**
 * 選択されている路線の駅のIDを全て除外する関数
 * @param {CompanyOfSearchModal[]} railwayCompanies - 路線・駅データ
 * @param {Object} options - チェック状態のオプション
 * @param {string[]} options.checkedAllRoute - チェックされた全ての路線
 * @param {string[]} options.checkedStation - チェックされた駅
 * @returns {Pick<CheckState, 'railwayCompanies' | 'checkedAllRoute' | 'checkedStation'>} 更新後のチェック状態
 */
export const removeStationChildIds = (
  railwayCompanies: CompanyOfSearchModal[],
  {
    checkedAllRoute,
    checkedStation,
  }: Pick<CheckState, 'checkedAllRoute' | 'checkedStation'>
) => {
  const stationIdsToRemove = getStationIdsByRoutes(
    railwayCompanies,
    checkedAllRoute
  );

  const filteredStation = checkedStation.filter(
    (id) => !stationIdsToRemove.includes(id)
  );

  return {
    checkedAllRoute,
    checkedStation: filteredStation,
  };
};
